// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OAuthAdminQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
}>;

export type OAuthAdminQuery = {
  __typename?: "GraphqlQuery";
  getOrganizationDetails?: {
    __typename?: "Organization";
    id: string;
    mcpEnabled: boolean;
    permittedToManageApiSettings: boolean;
  } | null;
};

export const OAuthAdminDocument = gql`
  query OAuthAdmin($organizationSlug: ID!) {
    getOrganizationDetails(organizationSlug: $organizationSlug) {
      id
      mcpEnabled
      permittedToManageApiSettings
    }
  }
`;

/**
 * __useOAuthAdminQuery__
 *
 * To run a query within a React component, call `useOAuthAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuthAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuthAdminQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOAuthAdminQuery(
  baseOptions: Apollo.QueryHookOptions<
    OAuthAdminQuery,
    OAuthAdminQueryVariables
  > &
    (
      | { variables: OAuthAdminQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<OAuthAdminQuery, OAuthAdminQueryVariables>(
    OAuthAdminDocument,
    options,
  );
}
export function useOAuthAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OAuthAdminQuery,
    OAuthAdminQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<OAuthAdminQuery, OAuthAdminQueryVariables>(
    OAuthAdminDocument,
    options,
  );
}
// @ts-ignore
export function useOAuthAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OAuthAdminQuery,
    OAuthAdminQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<OAuthAdminQuery, OAuthAdminQueryVariables>;
export function useOAuthAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OAuthAdminQuery,
        OAuthAdminQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OAuthAdminQuery | undefined,
  OAuthAdminQueryVariables
>;
export function useOAuthAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OAuthAdminQuery,
        OAuthAdminQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<OAuthAdminQuery, OAuthAdminQueryVariables>(
    OAuthAdminDocument,
    options,
  );
}
export type OAuthAdminQueryHookResult = ReturnType<typeof useOAuthAdminQuery>;
export type OAuthAdminLazyQueryHookResult = ReturnType<
  typeof useOAuthAdminLazyQuery
>;
export type OAuthAdminSuspenseQueryHookResult = ReturnType<
  typeof useOAuthAdminSuspenseQuery
>;
export type OAuthAdminQueryResult = Apollo.QueryResult<
  OAuthAdminQuery,
  OAuthAdminQueryVariables
>;
